module.exports = __webpack_public_path__ + "img/property-guard-logo.1c7757ab.png";